import { Module } from '@myme/utils/src/types';
import { v4 as uuidv4 } from 'uuid';
import { MymeEditorContext } from './types';

export const initialState: MymeEditorContext = {
  myme: {
    id: '',
    name: '',
    description: '',
    type: null,
    categoryId: '',
    availability: 'PUBLIC',
    participationCondition: 'FREE',
    price: null,
    password: null,
    contentDrippingCycleInSeconds: null,
    publishBlobAfterPreviousBlobIsFinished: false,
    previewImageFilePath: '',
    tags: [],
    modules: []
  },
  shouldBeDeletedOnUmount: false,
  step: 'NONE',
  isCreator: false,
  redirect: ''
};

export const initialModules: Module[] = [
  {
    name: 'Module 1',
    id: uuidv4(),
    blobs: [],
    isNew: true
  },
  {
    name: 'Module 2',
    id: uuidv4(),
    blobs: [],
    isNew: true
  }
];

export const getMockedInitialEditorState = (isCreator: boolean): MymeEditorContext => ({
  isCreator,
  step: 'EDIT_INTREST_DETAILS',
  myme: {
    id: 'test-myme-id',
    name: 'Test myme name',
    description: '',
    type: 'LOCATION_BASED',
    categoryId: '',
    availability: 'PUBLIC',
    participationCondition: 'FREE',
    price: null,
    password: null,
    contentDrippingCycleInSeconds: null,
    publishBlobAfterPreviousBlobIsFinished: false,
    previewImageFilePath: '',
    tags: [],
    modules: []
  },
  shouldBeDeletedOnUmount: false,
  redirect: ''
});
